/*
 * src/components/TransferSummary/TransferSummary.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React, { useState, useEffect } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { useForm } from 'react-hook-form';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useStateMachine } from 'little-state-machine';
import moment from 'moment';
import get from 'lodash/get';
import split from 'lodash/split';
import { getQueryVariable } from '../../utils/util';
import updateAction from '../CreateAccountWizard/updateAction';
import {
  PaymintsNumberFormat,
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import DestinationAccount from '../DestinationAccount/DestinationAccount';
import { useSaveTransfer } from '../../utils/service/service_transfer_api';
import MobileTransferSummary from './MobileTransferSummary/MobileTransferSummary';
import { getPlaidCreateClient } from '../../reducers/account/AccountActions';
import { startDwolla } from '../../reducers/transfer/TransferActions';
import FormatAddress from '../FormatAddress/FormatAddress';
import { useInstitutionLogo } from '../../utils/service/service_institution_logo';
import { useBankAccount } from '../../utils/service/service_bank_api';
import arrow from '../../styles/assets/Arrow_right.svg';
import useEscrowAccountFromTenant from '../../utils/service/service_tenant_api';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import HeaderLogo from '../../styles/assets/lemon.png';
import ContentModal from '../ContentModal/ContentModal';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import {
  extractNotesFromJson,
  paymintsCurrencyFormatter,
} from '../../utils/util';

import '../CreateAccountWizard/createAccount.css';
import './transfer-summary.css';

const Title = () => <div className="title">Review</div>;

const InfoTransfer = () => (
  <div className="infoTransfer">
    Please confirm that the information below is correct before continuing.
  </div>
);

/**
 * Taking the purpose string and possible adjustment
 * @param {*} purpose
 */
const transformPurpose = purpose => {
  if (!purpose) {
    return '--';
  }
  return purpose;
};

const DisplaySummationRows = ({ transfer }) => {
  return (
    <div className="summationContainer">
      <table>
        <tbody>
          <tr>
            <td style={{ textTransform: 'capitalize' }}>{`${transformPurpose(
              transfer?.purpose
            )} Amount`}</td>
            <td>{paymintsCurrencyFormatter(transfer?.amount || 0)}</td>
          </tr>
          {transfer?.fee && (
            <tr>
              <td>Convenience Fee</td>
              <td>{paymintsCurrencyFormatter(transfer?.fee || 0)}</td>
            </tr>
          )}
          <tr
            style={{
              borderTop: 'solid 1px #ccc',
              paddingTop: '5px',
              paddingBottom: '5px',
            }}
          >
            <td />
            <td className="transferTotalAmount">Transfer Total Amount</td>
          </tr>
          <tr>
            <td />
            <td className="transferTotal">
              <PaymintsNumberFormat
                number={+(transfer?.amount || 0) + +(transfer?.fee || 0)}
                decimals={2}
                format="currency"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const SummaryTransfer = ({
  transfer,
  bankAccount,
  bankAccountLogo,
  disbursement,
}) => {
  return (<>
    <MobileTransferSummary
      transfer={transfer}
      bankAccount={bankAccount}
      bankAccountLogo={bankAccountLogo}
      disbursement={disbursement}
    /> 
    <div className="sectionTitle">Details</div>
    <div className="detailsContainer">
      <div className="col">
        <div className="sectionTitle">Transfer Date</div>
        <p>{moment().format('MM/DD/YYYY')}</p>
      </div>
      <div className="col">
        <div className="sectionTitle">Purpose</div>
        <p style={{ textTransform: 'capitalize' }}>
          {transformPurpose(transfer?.purpose)}
        </p>
      </div>
      <div className="col">
        <div className="sectionTitle">Subject Property</div>
        <FormatAddress
          streetNumberName={get(transfer, 'propertyAddress1')}
          apartmentSuiteNumber={get(transfer, 'propertyAddress2')}
          city={get(transfer, 'propertyCity')}
          state={get(transfer, 'propertyState')}
          zipcode={get(transfer, 'propertyZipcode')}
        />
      </div>
      {transfer.office !== null ? (
        <div className="col">
          <div className="sectionTitle">Office</div>
          <p>
            {transfer?.office?.title} - {transfer?.office?.city},{' '}
            {transfer?.office?.state}
          </p>
        </div>
      ) : null}
      {transfer.realtor !== null ? (
        <div className="col">
          <div className="sectionTitle">Real Estate Agent</div>
          <p>
            {' '}
            {transfer?.realtor?.firstName} {transfer?.realtor?.lastName}{' '}
            {transfer?.realtor?.email}
          </p>
        </div>
      ) : null}
      <div className="col">
        <div className="sectionTitle">Note</div>
        <p>{extractNotesFromJson(transfer?.notes || '')}</p>
      </div>
    </div>

    <DisplaySummationRows transfer={transfer} />
  </>)
  
};

const UseDifferentAccountLink = ({ account, transferDwolla, history }) => (
  <div className="create-account__select-another-account-button">
    <Link
      disabled={
        get(account, 'createClient.isFetchingCreateClient') ||
        get(transferDwolla, 'startDwolla.isFetchingStartDwolla')
      }
      to={{
        pathname: '/create-account/step-select-account',
        search: `${get(history, 'location.search')}`,
        state: { fromSummary: true },
      }}
    >
      <PaymintsButton
        className="create-account__select-another-account-button"
        disabled={
          get(account, 'createClient.isFetchingCreateClient') ||
          get(transferDwolla, 'startDwolla.isFetchingStartDwolla')
        }
        loading={get(account, 'createClient.isFetchingCreateClient')}
        noShadow
        type={BUTTON_TYPE.LINK}
      >
        {'Use Different Account'}
      </PaymintsButton>
    </Link>
  </div>
);

const onClickBackButton = (history, disbursement, id) => {
  if (!disbursement) {
    history.push(`/create-account/step-3${get(history, 'location.search')}`);
  } else {
    history.push(
      `/create-account/step-select-account?go_to_transfer=${id}?disbursement="select-bank"`
    );
  }
};

const onClickGoToTransferHistory = history => history.push('/transfer-history');

const buildLoaderModal = () => (
  <div className="create-account__modal">
    <div className="create-account__modal-loading">
      <SpinnerLoader withoutMargin />
    </div>
    <div className="create-account__modal-info">
      Processing Fund Transfer ...
    </div>
  </div>
);

const TransferSummary = props => {
  const {
    history,
    client,
    transfer,
    onstartDwolla,
    transferDwolla,
    account,
  } = props;
  const { handleSubmit, getValues } = useForm({ defaultValues: transfer });
  const { state, action } = useStateMachine(updateAction);
  const { saveTransfer } = useSaveTransfer();
  const { bankAccount } = useBankAccount(get(state, 'data.bankAccount.id', ''));
  const { institutionLogo: bankAccountLogo } = useInstitutionLogo(
    get(bankAccount, 'institutionCode', '')
  );
  const { destBankAccount } = useEscrowAccountFromTenant(
    get(props, 'tenant.id', '')
  );
  const { institutionLogo } = useInstitutionLogo(
    get(destBankAccount, 'institutionCode', '')
  );

  const [error, onSetError] = useState({ active: false, messageError: '' });
  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const pathUrl = get(split(props.location.search, '?'), 2);
  const disbursement = getQueryVariable(pathUrl, 'disbursement');

  const onSubmit = (newTransfer, saveAsDraft = false) => {
    const path = get(split(props.location.search, '?'), 1);
    const transferId =
      getQueryVariable(path, 'go_to_transfer') || get(transfer, 'id');
    if (transferId) {
      // const disbursementData = {
      //   sourceBankAccountId: get(transfer, "sourceBankAccount.id"),
      //   destBankAccountId: get(state, "data.bankAccount.id"),
      //   transferId: transferId,
      // };
      const disbursementData = {
        sourceBankAccountId: get(state, 'data.bankAccount.id', ''),
        destBankAccountId: get(transfer, 'destBankAccount.id'),
        transferId: transferId,
      };

      const data = {
        sourceBankAccountId: get(state, 'data.bankAccount.id', ''),
        destBankAccountId: get(transfer, 'destBankAccount.id'),
        transferId: transferId,
      };
      if (saveAsDraft) {
        saveTransfer({
          variables: {
            id: transferId,
            transfer: {
              status: 'draft',
              tenant: {
                connect: {
                  id: get(props, 'tenant.id'),
                },
              },
              sourceBankAccount: {
                connect: {
                  id: get(state, 'data.bankAccount.id'),
                },
              },
            },
          },
        })
          .then(response => {
            handleClose();
            props.refetchTransfer({
              id: get(response, 'data.updateTransfer.id'),
            });
            action({ transfer: { ...props.transfer } });
          })
          .then(() => {
            if (saveAsDraft) {
              onClickGoToTransferHistory(props.history);
            }
          });
      } else {
        handleShow();
        onSetError({ active: false, messageError: '' });
        onstartDwolla(disbursement ? disbursementData : data, {
          type: disbursement ? 'disbursement' : null,
        }).then(response => {
          if (!get(response, 'error')) {
            handleClose();
            saveTransfer({
              variables: {
                id: transferId,
                transfer: {
                  status: 'pending',
                },
              },
            })
              .then(response => {
                props.refetchTransfer({
                  id: get(response, 'data.updateTransfer.id'),
                });
                action({ transfer: { ...props.transfer } });
              })
              .then(() => {
                if (saveAsDraft) {
                  onClickGoToTransferHistory(props.history);
                } else {
                  if (!disbursement) {
                    props.history.push(`/create-account/success`);
                  } else {
                    const path = get(split(props.location.search, '?'), 1);
                    const transferId =
                      getQueryVariable(path, 'go_to_transfer') || '';
                    props.history.push(
                      `/create-account/success?go_to_transfer=${transferId}?disbursement=success`
                    );
                  }
                }
              });
          } else {
            const customErrMsg = `Unfortunately, your transfer cannot be completed at this time due to connectivity issues with your financial institution. Please provide the closer with a certified check or contact ${
              props.tenant.name
            } at ${props.tenant.pocPhone ??
              'their primary phone number'} or email ${props.tenant
              .supportEmail ??
              'them'} to get wiring instructions specific to your transaction. We apologize for any inconvenience.`;

            handleClose();
            onSetError({
              active: true,
              // messageError: get(response, "message"),
              messageError: customErrMsg,
            });
          }
        });
      }
    }
  };
  const path = get(split(props.location.search, '?'), 1);
  const transferId = getQueryVariable(path, 'go_to_transfer') || '';
  const values = getValues();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ContentModal
        isVisible={showModal}
        onClose={handleClose}
        content={buildLoaderModal()}
        small
        withoutButtons
        hideCloseButton
      />
      <BoxContainer withDoubleBorder withLogButton>
        <Title disbursement={disbursement} />
        <form onSubmit={handleSubmit(e => onSubmit(e, false))}>
          {/* review and please confirm...*/}
          <InfoTransfer />

          {/* from account -> to account */}
          <div className="create-account__destination-account">
            <DestinationAccount
              title={`Transfer From:`}
              logoURL={disbursement ? HeaderLogo : ''}
              bankName={
                !disbursement
                  ? get(bankAccount, 'bankName')
                  : get(destBankAccount, 'bankName')
              }
              accountLastFourDigits={
                !disbursement
                  ? get(bankAccount, 'accountLastFourDigits')
                  : get(destBankAccount, 'accountLastFourDigits')
              }
              description={
                !disbursement
                  ? get(bankAccount, 'bankDisplayName')
                  : get(destBankAccount, 'bankDisplayName')
              }
              escrowAccountLogo={
                !disbursement
                  ? get(bankAccountLogo, 'logoURL')
                  : get(institutionLogo, 'logoURL')
              }
              name={`${get(client, 'firstName')} ${get(client, 'lastName')}`}
              tenantName={disbursement ? get(props, 'tenant.name') : ''}
              address1={
                !disbursement
                  ? get(client, 'address1')
                  : get(props, 'tenant.address1')
              }
              apartmentSuiteNumber={
                !disbursement
                  ? get(client, 'address2')
                  : get(props, 'tenant.address2')
              }
              city={
                !disbursement ? get(client, 'city') : get(props, 'tenant.city')
              }
              state={
                !disbursement
                  ? get(client, 'state')
                  : get(props, 'tenant.state')
              }
              zipcode={
                !disbursement
                  ? get(client, 'zipcode')
                  : get(props, 'tenant.zipcode')
              }
              type={!disbursement ? `from` : `to`}
            >
              <div
                className="create-account__use-different-account-link"
                hidden={bankAccount}
              >
                <UseDifferentAccountLink
                  account={account}
                  transferDwolla={transferDwolla}
                  history={history}
                  disbursement={disbursement}
                />
              </div>
            </DestinationAccount>
            <img
              className="create-account__destination-account-arrow-logo d-none d-lg-block"
              src={arrow}
              alt=""
            />
            <DestinationAccount
              title={`Transfer To:`}
              logoURL={!disbursement ? HeaderLogo : ''}
              bankName={
                disbursement
                  ? get(bankAccount, 'bankName')
                  : get(destBankAccount, 'bankName')
              }
              accountLastFourDigits={
                disbursement
                  ? get(bankAccount, 'accountLastFourDigits')
                  : get(destBankAccount, 'accountLastFourDigits')
              }
              description={
                disbursement
                  ? get(bankAccount, 'bankDisplayName')
                  : get(destBankAccount, 'bankDisplayName')
              }
              escrowAccountLogo={
                disbursement
                  ? get(bankAccountLogo, 'logoURL')
                  : get(institutionLogo, 'logoURL')
              }
              tenantName={get(props, 'tenant.name')}
              address1={
                disbursement
                  ? get(client, 'address1')
                  : get(props, 'tenant.address1')
              }
              apartmentSuiteNumber={
                disbursement
                  ? get(client, 'address2')
                  : get(props, 'tenant.address2')
              }
              city={
                disbursement ? get(client, 'city') : get(props, 'tenant.city')
              }
              state={
                disbursement ? get(client, 'state') : get(props, 'tenant.state')
              }
              zipcode={
                disbursement
                  ? get(client, 'zipcode')
                  : get(props, 'tenant.zipcode')
              }
              type={disbursement ? `from` : `to`}
            />
          </div>

          {/* the "Details" section */}
          <SummaryTransfer
            transfer={values}
            bankAccount={bankAccount}
            disbursement={disbursement}
            bankAccountLogo={get(bankAccountLogo, 'logoURL')}
          />

          <div className="create-account__footer-buttons create-account__mobile-transfer-footer-buttons">
            <PaymintsButton
              className="mr-4 create-account__transfer-action-button mobile__make-transfer-action-button"
              disabled={get(
                transferDwolla,
                'startDwolla.isFetchingStartDwolla'
              )}
              onClick={() => {
                props.refetchTransfer({
                  id: transferId,
                });
                onClickBackButton(props.history, disbursement, transferId);
              }}
              noShadow
              type={BUTTON_TYPE.LIGHT_BLUE}
            >
              <span className="button__name">{'< Back'}</span>
            </PaymintsButton>
            <PaymintsButton
              htmlType="submit"
              disabled={get(
                transferDwolla,
                'startDwolla.isFetchingStartDwolla'
              )}
              className="mr-4 create-account__transfer-action-button mobile__make-transfer-action-button"
              loading={get(transferDwolla, 'startDwolla.isFetchingStartDwolla')}
              noShadow
              type={BUTTON_TYPE.INVERSE_BLUE}
            >
              <span className="button__name">
                {!disbursement ? 'Make Transfer' : 'Accept Payment'}
              </span>
            </PaymintsButton>
            {/* <PaymintsButton
              disabled={get(
                transferDwolla,
                'startDwolla.isFetchingStartDwolla'
              )}
              className="create-account__save-come-back-button create-account__transfer-action-button"
              onClick={() => {
                if (disbursement) {
                  return history.push('/transfer-history');
                } else {
                  return handleSubmit(e => onSubmit(e, true));
                }
              }}
              noShadow
              type={BUTTON_TYPE.LINK}
            >
              <span className="button__name">{'Save & Come Back Later'}</span>
            </PaymintsButton> */}
            {error.active && (
              <ErrorMessageInput>{error.messageError}</ErrorMessageInput>
            )}
          </div>
        </form>
      </BoxContainer>
    </>
  );
};

export default withRouter(
  connect(
    state => ({
      account: state.account,
      transferDwolla: state.transfer,
    }),
    {
      onGetPlaidCreateClient: getPlaidCreateClient,
      onstartDwolla: startDwolla,
    }
  )(TransferSummary)
);